import { IPatron } from './../../models/service/patron-details.model';
import {
  AAddNursingStations,
  AAddPatronDetails,
  AAddUnitDetails,
  UpdateMealFilter,
  UpdateRoomFilter,
  AAddPatronTrayDetails,
} from './../actions/units.action';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { INursingStation } from 'src/app/models/service/nursing-stations.model';
import {
  IUnitsFilters,
  IUnitsDetailsGrouped,
} from '../../models/units/units-utilities.model';
import { IPatronTrayDetails } from '../../models/service/patron-tray-details.model';
import { Injectable } from '@angular/core';

export interface IUnitsStateModel {
  nursingStations: INursingStation[];
  unitDetails: IUnitsDetailsGrouped[];
  unitFilters: IUnitsFilters;
  patronDetails: IPatron;
  patronTrayDetails: IPatronTrayDetails;
}

@State<IUnitsStateModel>({
  name: 'UnitsState',
  defaults: {
    nursingStations: [],
    unitDetails: [],
    unitFilters: {
      rooms: [],
      alerts: [],
      meals: [],
      patronViews: [],
      hideDelivered: false,
    },
    patronDetails: null,
    patronTrayDetails: {
      data: [],
      totalSize: 0,
    },
  },
})
@Injectable({
  providedIn: 'root',
})
export class UnitsState {
  // Units
  @Selector()
  static getState(state: IUnitsStateModel): IUnitsStateModel {
    return state;
  }

  @Selector()
  static getCurrentPatronDetails(state: IUnitsStateModel): IPatron {
    return state.patronDetails;
  }

  @Selector()
  static getCurrentPatronTrayDetails(
    state: IUnitsStateModel,
  ): IPatronTrayDetails {
    return state.patronTrayDetails;
  }

  @Action(AAddNursingStations)
  addNursingStations(
    { patchState }: StateContext<IUnitsStateModel>,
    { payload }: AAddNursingStations,
  ): void {
    patchState({
      nursingStations: [...payload],
    });
  }

  @Action(AAddUnitDetails)
  addUnitDetails(
    { patchState }: StateContext<IUnitsStateModel>,
    { payload }: AAddUnitDetails,
  ): void {
    patchState({
      unitDetails: [...payload],
    });
  }

  @Action(UpdateRoomFilter)
  updateRoomFilter(
    { patchState }: StateContext<IUnitsStateModel>,
    { payload }: UpdateRoomFilter,
  ): void {
    const currentFilters = payload;
    patchState({
      unitFilters: currentFilters,
    });
  }

  @Action(AAddPatronDetails)
  AAddPatronDetails(
    { patchState }: StateContext<IUnitsStateModel>,
    { payload }: AAddPatronDetails,
  ): void {
    patchState({
      patronDetails: payload,
    });
  }

  @Action(AAddPatronTrayDetails)
  AAddPatronTrayDetails(
    { patchState }: StateContext<IUnitsStateModel>,
    { payload }: AAddPatronTrayDetails,
  ): void {
    patchState({
      patronTrayDetails: payload,
    });
  }

  @Action(UpdateMealFilter)
  UpdateMealFilter(
    { patchState, getState }: StateContext<IUnitsStateModel>,
    { payload }: UpdateMealFilter,
  ): void {
    const mealFilters = payload;
    const filters = getState().unitFilters;
    // filters.meals = mealFilters; //Shouldn't mutate objects coming from the state, better clone them a modify the output like down below, more: SO questions/55587708
    patchState({
      unitFilters: {...filters, meals: mealFilters},
    });
  }
}
